
















export default {
  props: {
    name: {
      type: String,
      default: "box",
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    color: {
      type: String,
      default: "currentColor",
    },
    viewBox: {
      type: String,
      default: "0 0 24 24",
    },
  },
};
